const CLAIM_COUPON_REQUEST = 'AMD50_CLAIM_COUPON_REQUEST'
const CLAIM_COUPON_SUCCESS = 'AMD50_CLAIM_COUPON_SUCCESS'
const CLAIM_COUPON_FAILURE = 'AMD50_CLAIM_COUPON_FAILURE'
const SAVE_SHIPPING_CACHE_REQUEST = 'AMD50_SAVE_SHIPPING_CACHE_REQUEST'
const SAVE_SHIPPING_CACHE_SUCCESS = 'AMD50_SAVE_SHIPPING_CACHE_SUCCESS'
const SAVE_SHIPPING_CACHE_FAILURE = 'AMD50_SAVE_SHIPPING_CACHE_FAILURE'
const SAVE_SHIPPING_FINAL_REQUEST = 'AMD50_SAVE_SHIPPING_FINAL_REQUEST'
const SAVE_SHIPPING_FINAL_SUCCESS = 'AMD50_SAVE_SHIPPING_FINAL_SUCCESS'
const SAVE_SHIPPING_FINAL_FAILURE = 'AMD50_SAVE_SHIPPING_FINAL_FAILURE'
const PREV_REDEEM_STATE = 'AMD50_PREV_REDEEM_STATE'
const NEXT_REDEEM_STATE = 'AMD50_NEXT_REDEEM_STATE'
const CLEAR_REDEEM_STATE = 'AMD50_CLEAR_REDEEM_STATE'
const TERMS_REQUEST = 'AMD50_TERMS_REQUEST'
const TERMS_SUCCESS = 'AMD50_TERMS_SUCCESS'
const TERMS_FAILURE = 'AMD50_TERMS_FAILURE'
const SET_FAQ_ACTIVE_REQUEST = 'AMD50_SET_FAQ_ACTIVE_REQUEST'

export default {
  CLAIM_COUPON_REQUEST,
  CLAIM_COUPON_SUCCESS,
  CLAIM_COUPON_FAILURE,
  SAVE_SHIPPING_CACHE_REQUEST,
  SAVE_SHIPPING_CACHE_SUCCESS,
  SAVE_SHIPPING_CACHE_FAILURE,
  SAVE_SHIPPING_FINAL_REQUEST,
  SAVE_SHIPPING_FINAL_SUCCESS,
  SAVE_SHIPPING_FINAL_FAILURE,
  PREV_REDEEM_STATE,
  NEXT_REDEEM_STATE,
  CLEAR_REDEEM_STATE,
  TERMS_REQUEST,
  TERMS_SUCCESS,
  TERMS_FAILURE,
  SET_FAQ_ACTIVE_REQUEST,
}
